import { StrongText } from '../../../../components/ui'
import { GradientSphereMetricCard, sphereColorAt } from '../../components/GradientSphereCard'

interface TestsSummaryStatsProps {
  partnerCount: number
  catalogCount: number
  categoryCount: number
}

export function TestsSummaryStats({ partnerCount, catalogCount, categoryCount }: TestsSummaryStatsProps) {
  return (
    <div className="tests-summary-grid mt-4">
      <GradientSphereMetricCard
        label="Partners"
        value={<StrongText as="span" size="lg">{partnerCount}</StrongText>}
        sphereColor={sphereColorAt(0)}
        labelVariant="section"
        className="tests-summary-stat"
      />
      <GradientSphereMetricCard
        label="Catalog"
        value={<StrongText as="span" size="lg">{catalogCount}</StrongText>}
        sphereColor={sphereColorAt(1)}
        labelVariant="section"
        className="tests-summary-stat"
      />
      <GradientSphereMetricCard
        label="Categories"
        value={<StrongText as="span" size="lg">{categoryCount}</StrongText>}
        sphereColor={sphereColorAt(2)}
        labelVariant="section"
        className="tests-summary-stat"
      />
    </div>
  )
}
